<template>
  <div
    v-html="normalize(contentPart(handle))"
  >

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    handle: String
  },
  name: 'contentPart',
  data () {
    return {

    }
  },
  components: {

  },
  methods: {
    contentPart (handle) {
      return this.contentParts.find(cp => cp.handle === handle).text
    }
  },
  computed: {
    ...mapGetters({
      contentParts: 'getContentParts'
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
